import endPoints from "../../../../../config/endPoints";
import axios from "axios";


export const getAllReferenceByKindApi = async(kindId) => {  
    return await axios.get(`${endPoints.references}/${kindId}`);  
};

export const getAllReferences = async () => {
    return await axios.get(endPoints.references);
};

export const getAllReferencesKinds = async () => {
    return await axios.get(endPoints.refKinds);
};

// export const getAllReferenceByKindApi = async(reqBody) => {  
//     return await axios.get(`${endPoints.references}/kindId`, reqBody);  
// };

// export const getAllReferences = async (reqBody) => {
//     return await axios.get(endPoints.references, reqBody);
// };

// export const getAllReferencesKinds = async (reqBody) => {
//     return await axios.get(endPoints.refKinds, reqBody);
// };
